
export const deleteObjectMapping = (data) => ({
    payload: data,
    type: 'DELETE_OBJECT_MAPPING'
});

export const newMigration = (data) => ({
    payload: data,
    type: 'NEW_MIGRATION'
});

export const getMigration = (data) => ({
    payload: data,
    type: 'GET_MIGRATION',
});

export const setMigration = (data) => ({
    payload: data,
    type: 'SET_MIGRATION'
});

export const getRecordCount = (data) => ({
    payload: data,
    type: 'GET_RECORD_COUNT'
});

export const setRecordCount = (data) => ({
    payload: data,
    type: 'SET_RECORD_COUNT'
});

export const syncCounters = (data) => ({
    payload: data,
    type: 'SYNC_COUNTERS'
});

export const getMigrations = () => ({
    type: 'GET_MIGRATIONS'
});

export const setMigrations = (data) => ({
    payload: data,
    type: 'SET_MIGRATIONS',
});

export const setModalObj = (data) => ({
    payload: data,
    type: 'SET_MODAL_OBJ',
});

export const setDeltaMigration = (data) => ({
    payload: data,
    type: 'SET_DELTA_MIGRATION',
});

export const setActiveTab = (data) => ({
    payload: data,
    type: 'SET_ACTIVE_TAB',
});

export const initiateDeltaMigration = (data) => ({
    payload: data,
    type: 'INITIATE_DELTA_MIGRATION',
});

export const createDeltaMigration = (data) => ({
    payload: data,
    type: 'CREATE_DELTA_MIGRATION',
});

export const connectPlatform = (data) => ({
    payload: data,
    type: 'CONNECT_PLATFORM',
});

export const setSelectedObjects = (data) => ({
    payload: data,
    type: 'SET_SELECTED_OBJECTS',
});

export const setSupportedObjects = (data) => ({
    payload: data,
    type: 'SET_SUPPORTED_OBJECTS',
});

export const downloadCSV = (data) => ({
    payload: data,
    type: 'DOWNLOAD_CSV',
});

export const setDownloadCSV = (data) => ({
    payload: data,
    type: 'SET_DOWNLOAD_CSV',
});

export const restartObject = (data) => ({
    payload: data,
    type: 'RESERT_OBJECT',
});

export const uploadFields = (data) => ({
    payload: data,
    type: 'UPLOAD_FIELDS',
});

export const getFieldsMapping = (key, objectsMapping) => ({
    payload: { key, objectsMapping },
    type: 'GET_FIELDS_MAPPING'
});

export const setFieldsMapping = (data) => ({
    payload: data,
    type: 'SET_FIELDS_MAPPING'
});

export const setHubspotMapping = (data) => ({
    payload: data,
    type: 'SET_HUBSPOT_MAPPING'
});

export const setDeleteMigration = (data) => ({
    payload: data,
    type: 'SET_DELETE_MIGRATION'
});

export const removeField = (data) => ({
    payload: data,
    type: 'REMOVE_FIELD'
});

export const nextFieldMapping = (data) => ({
    payload: data,
    type: 'NEXT_FIELD_MAPPING'
});

export const setupSample = (data) => ({
    payload: data,
    type: 'SETUP_SAMPLE'
});

export const setPaymentStatusAction = (data) => ({
    payload: data,
    type: 'SET_PAYMENT_STATUS'
});

export const scheduleFullMigration = (data) => ({
    payload: data,
    type: 'SCHEDULE_FULL_MIGRATION'
});

export const setupFullMigration = (data) => ({
    payload: data,
    type: 'SETUP_FULL_MIGRATION'
});

export const getResults = (data) => ({
    payload: data,
    type: 'GET_RESULTS'
});

export const setResults = (data) => ({
    payload: data,
    type: 'SET_RESULTS'
});

export const setResultPages = (data) => ({
    payload: data,
    type: 'SET_RESULT_PAGES'
});

export const setResultTotal = (data) => ({
    payload: data,
    type: 'SET_RESULT_TOTAL'
});

export const getErrors = (data) => ({
    payload: data,
    type: 'GET_ERRORS'
});

export const setErrors = (data) => ({
    payload: data,
    type: 'SET_ERRORS'
});

export const markErrorsResolved = (data) => ({
    payload: data,
    type: 'MARK_ERRORS_RESOLVED'
});

// Optimistic local flip of resolved state on error rows (by id) — no backend call.
export const applyErrorsResolved = (data) => ({
    payload: data, // { ids: [], resolved }
    type: 'APPLY_ERRORS_RESOLVED'
});

export const autoFixOptions = (data) => ({
    payload: data,
    type: 'AUTO_FIX_OPTIONS'
});

export const setAutoFixResult = (data) => ({
    payload: data,
    type: 'SET_AUTOFIX_RESULT'
});

export const getStripeSecret = (data) => ({
    payload: data,
    type: 'GET_STRIPE_SECRET'
});

export const setStripeSecret = (data) => ({
    payload: data,
    type: 'SET_STRIPE_SECRET'
});

export const createRelations = (data) => ({
    payload: data,
    type: 'CREATE_RELATIONS'
});

export const resyncSoftData = (data) => ({
    payload: data,
    type: 'RESYNC_SOFT_DATA'
});

export const resumeMigration = (data) => ({
    payload: data,
    type: 'RESUME_MIGRATION'
});

export const deleteObject = (data) => ({
    payload: data,
    type: 'DELETE_OBJECT'
});

export const saveNewObjectMapping = (data) => ({
    payload: data,
    type: 'SAVE_NEW_OBJECT_MAPPING'
});

export const saveNewMapping = (data) => ({
    payload: data,
    type: 'SAVE_NEW_MAPPING'
});

export const addHubspotProperty = (data) => ({
    payload: data,
    type: 'ADD_HUBSPOT_PROPERTY'
});

export const updateErrorPopup = (data) => ({
    payload: data,
    type: 'UPDATE_ERROR_POPUP'
});

export const downloadFile = (data) => ({
    payload: data,
    type: 'DOWNLOAD_FILE'
});

export const setAttachmentsImportStatus = (data) => ({
    payload: data,
    type: 'SET_ATTACHMENTS_IMPORT_STATUS'
});

export const saveReportColumns = (data) => ({
    payload: data,
    type: 'SAVE_REPORT_COLUMNS'
});